function toPathHref(path: string): string {
  const trimmed = path.trim().replace(/^\/+|\/+$/g, "");
  return trimmed ? `/${trimmed}/` : "/";
}

export function buildServiceHref(path: string): string {
  return toPathHref(path);
}

export function getHomeHref(): string {
  return "/";
}
